import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule as PrimeNGAutoCompleteModule, ButtonModule, DialogModule, InputTextModule, TooltipModule } from 'primeng/primeng';
import { TranslateModule } from '@ngx-translate/core';

import { AutocompleteComponent } from './autocomplete.component';
import { AutocompleteModalComponent } from './autocomplete-modal/autocomplete-modal.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PrimeNGAutoCompleteModule,
    TranslateModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    TooltipModule
  ],
  declarations: [
    AutocompleteComponent,
    AutocompleteModalComponent
  ],
  exports: [
    AutocompleteComponent
  ],
  entryComponents: [
    AutocompleteModalComponent
  ]
})
export class AutocompleteModule { }



// WEBPACK FOOTER //
// /dist/src/app/shared/autocomplete/autocomplete.module.ts